import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AimfoxLogoGradient from "assets/aimfoxLogos/aimfox-logo-gradient.svg?react";

export default function Heading() {
  const isDesktop = useTwBreakpoint("lg");

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  if (isDesktop) {
    return (
      <div className="flex gap-x-5">
        <AimfoxLogoGradient className="size-[52px]" />

        <div>
          <span className="text-sm-bold">Welcome to Aimfox</span>
          <Title className="mb-1 px-0 text-left text-3xl-bold">
            Your trial is live!
          </Title>
          <Description className="mt-0 px-0 text-left text-sm-medium">
            Enjoy 14 days of unlimited free trial, with full access to all
            features
          </Description>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-2.5 items-center">
      <div className="flex gap-x-4">
        <AimfoxLogoGradient className="size-10" />

        <div>
          <span className="text-xs-medium">Welcome to Aimfox</span>
          <Title className="text-xl-bold">Your trial is live!</Title>
        </div>
      </div>

      <Description className="mt-0 text-xs-medium">
        Enjoy 14 days of unlimited free trial, with full access to all features
      </Description>
    </div>
  );
}
